export default "__VITE_ASSET__db5867f6__"